/**
 * Implements a "lazyplay" feature (think lazyload, but with video playback).
 *
 * This feature will:
 *
 * 1. Pause any videos that are playing when:
 * - Our browser window is minimized
 * - Our browser tab is no longer the active tab
 * - Video element is outside the viewport
 *
 * 2. Resume playback of aforementioned videos when they become visible again.
 */
(() => {
    let videos = document.querySelectorAll('.js-video');

    function refreshAll() {
        videos.forEach(H_Tools.video.refresh);
    }

    videos.forEach(H_Tools.video.allowPlayPause);
    document.addEventListener('visibilitychange', refreshAll);
    window.addEventListener('resize-debounce', refreshAll);
    window.addEventListener('scroll-throttle', refreshAll);
    videos.forEach(H_Tools.viewport.observe);
    // refreshAll();
    H_Tools.video.reduceMotion(document);
})();
